// Owner: design-system (plan §3.2, §9.1). Settings › Workspace › Branding.
import { createFileRoute } from '@tanstack/react-router';
import { BrandingPage } from '../../../features/branding/BrandingPage';

export const Route = createFileRoute('/_settings/settings/branding')({
  component: BrandingPage,
});
